import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const useSlashRemover = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (location.pathname !== '/' && location.pathname.endsWith('/')) {
      navigate(location.pathname.slice(0, -1) + location.search, { replace: true })
    }
  }, [location, navigate])
}
